import "./src/styles/global.css";
import "vanilla-cookieconsent/dist/cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

export { wrapRootElement } from "./src/hooks/useAuth";
